import { useMemo } from 'react';
import { useSelector } from 'react-redux';

import { usePrivateWorkspaceAgentPanelSession } from '~/components/v2/components/workspace/workspace-agent-panel/PrivateWorkspaceAgentPanelProvider';
import { usePrivateWorkspaceAgentPromptCardClipsSearch } from '~/components/v2/components/workspace/workspace-agent-panel/queries/usePrivateWorkspaceAgentPromptCardClipsSearch';
import { toWorkspaceAgentPromptCardThumbnails } from '~/components/v2/components/workspace/workspace-agent-panel/utils/toWorkspaceAgentPromptCardThumbnails';
import { centralizedBoardIdSelector, centralizedBoardTitleSelector } from '~/store/centralizedBoard/selectors';

export const usePrivateWorkspaceAgentUntaggedAssetsPromptCard = () => {
  const { workspaceId } = usePrivateWorkspaceAgentPanelSession();
  const boardId = useSelector(centralizedBoardIdSelector);
  const boardTitle = useSelector(centralizedBoardTitleSelector);

  const filters = useMemo(
    () => ({
      untagged: { is: true },
      ...(boardId ? { board: { is: boardId } } : {}),
    }),
    [boardId],
  );

  const { data, isLoading } = usePrivateWorkspaceAgentPromptCardClipsSearch({ filters, workspaceId });

  const clips = data?.data.clips;
  const thumbnails = useMemo(() => toWorkspaceAgentPromptCardThumbnails(clips ?? []), [clips]);
  const total = data?.data.total ?? 0;

  return {
    boardName: boardId ? boardTitle || 'Untitled board' : undefined,
    isPending: isLoading,
    thumbnails,
    total,
  };
};
